module.exports = __webpack_public_path__ + "static/img/ua_block_rgb_3.0a5e0d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ua_block_rgb_3.png
// module id = tKag
// module chunks = 1